import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { CosmicBackground } from "../components/CosmicBackground";
import { Loader2, Sparkles, Check } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/dashboard");
      return;
    }
    let cancelled = false;
    const poll = async (attempt) => {
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        if (cancelled) return;
        setTries(attempt);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (attempt >= 8) {
          setStatus("pending");
          return;
        }
        setTimeout(() => poll(attempt + 1), 2000);
      } catch {
        setStatus("error");
      }
    };
    poll(1);
    return () => {
      cancelled = true;
    };
  }, [params, navigate]);

  return (
    <CosmicBackground>
      <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success">
        {status === "checking" && (
          <>
            <Loader2 size={36} className="mx-auto animate-spin text-[#D4AF37]" />
            <p className="mt-4 font-serif-mystic text-3xl">Confirming with the stars…</p>
            <p className="text-[#94A3B8] mt-2 text-sm">Attempt {tries}/8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="mx-auto w-20 h-20 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mb-4">
              <Check size={36} className="text-[#D4AF37]" strokeWidth={2} />
            </div>
            <h1 className="font-serif-mystic text-4xl gold-shimmer">You are a Quester.</h1>
            <p className="text-[#94A3B8] mt-3">All quests, compatibility, and astrocartography are now unlocked.</p>
            <Button
              onClick={() => navigate("/dashboard")}
              data-testid="success-dashboard-btn"
              className="mt-6 bg-[#D4AF37] text-[#05070A] hover:bg-[#F3E5AB]"
            >
              <Sparkles size={14} strokeWidth={2} className="mr-2" />
              Continue to dashboard
            </Button>
          </>
        )}
        {status === "expired" && (
          <>
            <p className="font-serif-mystic text-3xl">Session expired.</p>
            <Button onClick={() => navigate("/pricing")} className="mt-6 bg-[#D4AF37] text-[#05070A]">
              Try again
            </Button>
          </>
        )}
        {status === "pending" && (
          <p className="font-serif-mystic text-2xl">Still processing — we&apos;ll confirm by email.</p>
        )}
        {status === "error" && (
          <p className="font-serif-mystic text-2xl">Something went wrong. Please contact support.</p>
        )}
      </div>
    </CosmicBackground>
  );
}
